import React from 'react';
import { useAorText } from 'utils/aorTerminology';

import { Badge } from '@/components/ui/badge';
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from '@/components/ui/item';

export type ActionListCardAction = {
  id: string;
  name: string;
  status?: string | null;
  priority?: string | null;
  aor_name?: string | null;
};

type ActionListCardProps = {
  action: ActionListCardAction;
  matchReason?: 'area' | 'aor';
};

const ActionListCard: React.FC<ActionListCardProps> = ({
  action,
  matchReason,
}) => {
  const aorText = useAorText();
  const matchLabel = aorText(
    matchReason === 'aor' ? 'Assigned AOR' : 'In area'
  );
  return (
    <Item
      variant="outline"
      size="xs"
      className="tw:min-w-0 tw:max-w-full tw:bg-card tw:p-2.5"
    >
      <ItemContent className="tw:min-w-0">
        <ItemTitle className="tw:text-sm">{action.name}</ItemTitle>
        <ItemDescription className="tw:flex tw:flex-wrap tw:gap-1.5">
          {action.status ? (
            <Badge variant="outline">{action.status}</Badge>
          ) : null}
          {action.priority ? (
            <Badge variant="outline">{action.priority}</Badge>
          ) : null}
          {action.aor_name ? (
            <span className="tw:text-xs tw:text-muted-foreground">
              {action.aor_name}
            </span>
          ) : null}
          {matchReason ? (
            <span className="tw:text-xs tw:text-muted-foreground">
              {matchLabel}
            </span>
          ) : null}
        </ItemDescription>
      </ItemContent>
    </Item>
  );
};

export default ActionListCard;
